/**
 * File Icon Mapper
 * @description MIMEタイプに基づいてファイルアイコンを取得するユーティリティ
 */

import { match, P } from 'ts-pattern';
import type { IconName } from '@/components/Icon/iconMap';

/**
 * MIMEタイプに基づいてファイルアイコンを取得
 * @param mimeType - ファイルのMIMEタイプ
 * @returns アイコン名
 */
export function getFileIcon(mimeType: string): IconName {
  return match(mimeType).with('application/pdf', () => 'FileTextIcon' as const).with(P.union('application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'), () => 'FileTextIcon' as const).with(P.union('application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv'), () => 'FileSpreadsheet' as const).with(P.union('application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'), () => 'FileTextIcon' as const).with(P.string.startsWith('text/'), () => 'FileTextIcon' as const).with(P.union('application/zip', 'application/x-rar-compressed', 'application/x-7z-compressed'), () => 'FileXIcon' as const).with(P.string.startsWith('image/'), () => 'ImageIcon' as const).otherwise(() => 'FileTextIcon' as const);
}